import { authConfig } from '../config/auth.config';
import keycloak from '../keycloak-init';

/**
 * Socket.IO options for gateway namespaces in prod (multi-replica).
 * Uses websocket-only to avoid "Session ID unknown" from polling across pods.
 */
export function buildGatewaySocketOptions(): {
  options: Record<string, unknown>;
  token: string | undefined;
} {
  let token = keycloak.token || localStorage.getItem('token') || authConfig.token;

  if (keycloak.authenticated && keycloak.token) {
    keycloak.updateToken(30).catch(() => {});
    token = keycloak.token;
  }

  const options: Record<string, unknown> = {
    transports: ['websocket'],
    upgrade: false,
    reconnection: true,
    reconnectionAttempts: 10,
    reconnectionDelay: 1000,
    reconnectionDelayMax: 5000,
    timeout: 20000,
    auth: token ? { token } : undefined,
    extraHeaders: token ? { Authorization: `Bearer ${token}` } : undefined,
  };

  return { options, token };
}
